import { MemberService } from "@/generated/services/MemberService";
import { useMutation } from "@tanstack/react-query";

export function useFetchMemberMutation() {
  return useMutation({
    mutationFn: async (memberId: number) => {
      const response = await MemberService.getMembers(memberId);
      return {
        ...response,
      };
    },
  });
}
